import { Container, Box } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import React from "react";
import FTLButton from "../buttons/FTLButton";
import FTLTypography from "../other/FTLTypography";
const buttonComponents = (buttons, history, basePath) => {
    if (buttons &&
        typeof buttons !== "function" &&
        !React.isValidElement(buttons) &&
        Array.isArray(buttons))
        return buttons.map((buttonName) => {
            switch (buttonName) {
                case "goBack":
                    return (React.createElement(FTLButton, { onClick: () => {
                            if (history.length)
                                history.goBack();
                            else
                                history.push(basePath);
                        }, color: "primary" }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434"));
                case "toLoginPage":
                    return (React.createElement(FTLButton, { onClick: () => {
                            history.push("/");
                        }, color: "primary" }, "\u0412\u043E\u0439\u0442\u0438"));
                case "refresh":
                    return (React.createElement(FTLButton, { onClick: () => window.location.reload(), color: "primary" }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"));
                default:
                    return null;
            }
        });
    else
        return buttons;
};
export default ({ hasError = true, title = "Что-то пошло не так...", buttons = ["goBack"], message, children, basePath = "/", fullScreen, }) => {
    var _a, _b, _c, _d, _e, _f;
    const history = useHistory();
    return hasError ? (React.createElement(Container, { maxWidth: "xs", style: { height: "100%" } },
        React.createElement(Box, { display: "flex", height: fullScreen && "100%", mt: !fullScreen && 4, alignItems: "center", flexDirection: "column", justifyContent: "center" },
            React.createElement(FTLTypography, { variant: "h1", align: "center" }, (_c = (_b = (_a = history === null || history === void 0 ? void 0 : history.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : title),
            React.createElement(Box, { mt: 3, maxWidth: "500px" },
                React.createElement(FTLTypography, { align: "center", variant: "p3", display: "block" }, (_f = (_e = (_d = history === null || history === void 0 ? void 0 : history.location) === null || _d === void 0 ? void 0 : _d.state) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : message)),
            React.createElement(Box, { mt: 6, display: "flex" }, history && buttonComponents(buttons, history, basePath))))) : (React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=FTLErrorPage.js.map